import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import Icon from '@/components/icon/Icon.vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTokenButton',
  props: {
    full: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {



const { state } = useStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button-control button-control_gray",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    (!_unref(state).layout.isMobile || __props.full)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: "add",
          size: "12"
        }))
      : _createCommentVNode("", true),
    _createVNode(Icon, {
      name: "metamaskFox",
      size: "16"
    })
  ]))
}
}

})